import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoggingService } from '../logging/logging.service';
import { CustomErrorBase } from './models/custom-error.models';

export const logCustomError = (
  customError: CustomErrorBase,
  app: string,
  library: string,
  feature: string,
  details = ''
) => {
  const error: Error = {
    name: customError.code,
    message: `${customError.message} ${details}`.trim()
  };

  logError(error, app, library, feature);
};

export const logError = (
  error: Error,
  app: string,
  library: string,
  feature: string,
  details = ''
) => {
  const logging = new LoggingService(Object);
  const errorMessage =
    `[${feature}]: ${error.name} → ${error.message} ${details}`.trim();

  logging.app = app;
  logging.library = library;
  logging.feature = feature;
  logging.log(errorMessage);
};

export const handleError = (
  error: HttpErrorResponse,
  app: string,
  library: string,
  feature: string
): Observable<never> => {
  let details = '';
  if (error?.error?.error) {
    details += ` | ${error.error.error.message}`;
  }
  logError(error, app, library, feature, details);
  return throwError(error);
};
